import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Direction } from "../core/model/direction";
import { DirectionService } from "../core/service/direction.service";
import { AddDirectionComponent } from "./add-direction/add-direction.component";
import { EditDirectionComponent } from "./edit-direction/edit-direction.component";

@Component({
  selector: "app-direction",
  templateUrl: "./direction.component.html",
  styleUrls: ["./direction.component.scss"],
})
export class DirectionComponent implements OnInit {
  directions: Direction[];

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _drectionService: DirectionService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getDirections();
  }

  getDirections() {
    this._drectionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  add(): void {
    const modalRef = this.modalService.open(AddDirectionComponent, {
      centered: true,
    });

    modalRef.result.then(
      (data) => {
        // on close
        this.getDirections();
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  edit(direction: Direction): void {
    const modalRef = this.modalService.open(EditDirectionComponent, {
      centered: true,
    });
    modalRef.componentInstance.direction = direction;

    modalRef.result.then(
      (updated: Direction) => {
        if (updated && this.directions) {
          const index = this.directions.findIndex((d) => d.id === updated.id);
          if (index !== -1) {
            this.directions[index] = updated;
            this.directions = [...this.directions];
            return;
          }
        }
        this.getDirections();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
